import React, { Fragment } from 'react';
import { Anchor } from '../anchor';
import { useRenderer } from '../renderer';
export function RichText({ className, document }) {
    return (React.createElement("div", { className: className }, document.content.flatMap(mapNodeToReactElement)));
}
function mapNodeToReactElement(node, index) {
    var _a;
    const renderer = useRenderer();
    switch (node.type) {
        case 'blockquote':
            return [mapBlockquoteToReactElement(node, index)];
        case 'bulletList':
            return [
                React.createElement("ul", { key: `ul-${index}` }, node.content.map(mapNodeToReactElement))
            ];
        case 'heading':
            return [mapHeadingToReactElement(node, index)];
        case 'listItem':
            return [
                React.createElement("li", { key: `li-${index}` }, node.content.map(mapNodeToReactElement))
            ];
        case 'paragraph':
            return [
                React.createElement("p", { key: `p-${index}` }, (_a = node.content) === null || _a === void 0 ? void 0 : _a.map(mapNodeToReactElement))
            ];
        case 'rule':
            return [React.createElement("hr", { key: `hr-${index}` })];
        case 'text':
            return mapTextToReactElement(node, index);
        case 'orderedList':
            return [
                React.createElement("ol", { key: `ol-${index}` }, node.content.map(mapNodeToReactElement))
            ];
        case 'bxpEmbeddedViewBlock':
            return [
                React.createElement(Fragment, { key: `block-${index}` }, renderer(node.model))
            ];
        case 'bxpEmbeddedViewInline':
            return [
                React.createElement(Fragment, { key: `inline-${index}` }, renderer(node.model))
            ];
    }
}
function mapBlockquoteToReactElement({ content }, index) {
    return (React.createElement("blockquote", { key: `blockquote-${index}` }, content.map(mapNodeToReactElement)));
}
function mapHeadingToReactElement({ attrs, content = [] }, index) {
    const children = content.map(mapNodeToReactElement);
    switch (attrs.level) {
        case 1:
            return React.createElement("h1", { key: `h1-${index}` }, children);
        case 2:
            return React.createElement("h2", { key: `h2-${index}` }, children);
        case 3:
            return React.createElement("h3", { key: `h3-${index}` }, children);
        case 4:
            return React.createElement("h4", { key: `h4-${index}` }, children);
        case 5:
            return React.createElement("h5", { key: `h5-${index}` }, children);
        case 6:
            return React.createElement("h6", { key: `h6-${index}` }, children);
    }
}
function mapTextToReactElement({ text, marks = [] }, index) {
    const [mark, ...otherMarks] = marks;
    if (mark) {
        const children = mapTextToReactElement({
            type: 'text',
            text,
            marks: otherMarks
        }, index);
        switch (mark.type) {
            case 'code':
                return [React.createElement("code", { key: `code-${index}` }, children)];
            case 'em':
                return [React.createElement("em", { key: `em-${index}` }, children)];
            case 'strong':
                return [React.createElement("strong", { key: `strong-${index}` }, children)];
            case 'underline':
                return [React.createElement("u", { key: `u-${index}` }, children)];
            case 'link':
                return [
                    React.createElement(Anchor, { key: `a-${index}`, href: mark.attrs.href }, children)
                ];
        }
    }
    else {
        const [firstChunk, ...otherChunks] = text.split('\n');
        if (otherChunks.length > 0) {
            return [
                React.createElement(Fragment, { key: `first-fragment-${index}` }, firstChunk),
                ...otherChunks.flatMap((otherChunk, _index) => [
                    React.createElement("br", { key: `br-${_index}` }),
                    React.createElement(Fragment, { key: `other-fragment-${_index}` }, otherChunk)
                ])
            ];
        }
        else {
            return [React.createElement(Fragment, { key: `fragment-${index}` }, text)];
        }
    }
}
//# sourceMappingURL=RichText.js.map